import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PinOverride } from '@emm/core/models/pin-override.model';

@Component({
    selector: 'emm-file-upload-dialog',
    templateUrl: './file-upload-dialog.component.html',
    styleUrls: ['./file-upload-dialog.component.scss'],
    standalone: false
})
export class FileUploadDialogComponent implements OnInit {

  fileName = '';
  fileArray: PinOverride[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public fileUploadRef: MatDialogRef<FileUploadDialogComponent>,
  ) { }

  public ngOnInit() {
  }

  onFileSelected(event) {
    const file = event.target.files[0];
    if (file) {
      this.fileName = file.name;
      const formData = new FormData();
      formData.append('thumbnail', file);
    }
    if (window.FileReader) {
      this.parseFile(file, this.fileArray);
    } else {
      alert('FileReader is not supported by this browser');
    }
  }

  parseFile(file: File, fileArray: PinOverride[]) {
    const fileReader = new FileReader();
    fileReader.readAsText(file);
    fileReader.onload = (event: any) => {
      const csv = event.target.result;
      let newPinOverride: PinOverride;
      const newPinOverrides: PinOverride[] = [];
      const fileData = [];
      let rows;
      let cols;

      rows = csv.split('\r\n');
             for (let i = 0; i < rows.length; i++) {
        cols = rows[i].split(',');
        const firstColAsNum = cols[0] * 1;
        const isFirstColNum = !isNaN(firstColAsNum);
        if (cols.length > 5 || !isFirstColNum) {
          alert('Your file format was incorrect, please try again!');
          break;
        }
        fileData.push(cols);
      }

             for (let i = 0; i < fileData.length; i++) {
        newPinOverride = {
          id: null,
          rmi: fileData[i][0] as number,
          primaryOverride: fileData[i][1] as number,
          secondaryOverride: fileData[i][2] as number,
          wholeProductOverride: fileData[i][3] as number,
          samplingDistributionOverride: fileData[i][4] as number,
        };
        newPinOverrides.push(newPinOverride);
        fileArray = newPinOverrides.filter(result => result.rmi > 0);
      }
      return fileArray;
    };
    fileReader.onerror = this.errorHandler;
    setTimeout(() => {
      this.closeDialog(fileArray);
    }, 500);
  }

  closeDialog(fileArray): void {
    this.fileUploadRef.close({ fileArray});
  }

  errorHandler(event: any): any {
    if (event.target.error.name === 'NotReadableError') {
      alert('Cannot read file!');
      this.fileUploadRef.close();
    }
  }
}
